import { render } from "./zygcfx.vue?vue&type=template&id=3fe63354&scoped=true&ts=true"
import script from "./zygcfx.vue?vue&type=script&lang=ts"
export * from "./zygcfx.vue?vue&type=script&lang=ts"

import "./zygcfx.vue?vue&type=style&index=0&id=3fe63354&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe63354"]])

export default __exports__